import React from "react";
import styled from "styled-components";
import { Color } from "@glossy/colors";
import { Locale } from "@linkfluence/models/locale";
import Loader from "@ui-kit/loader/dots";
import { tr } from "@radarly/i18n";

interface IProps {
  error: boolean;
  loading: boolean;
  locale: Locale;
  children: React.ReactNode;
}

const Wrapper = styled.div`
  text-align: center;
  color: ${Color.DarkGrey};
`;

function RadarlyFilterbarPanelsInnerPanel({
  error,
  loading,
  locale,
  children,
}: IProps) {
  return (
    <>
      {loading ? (
        <Wrapper>
          <Loader />
        </Wrapper>
      ) : error ? (
        <Wrapper>{tr(locale, "FILTERBAR::PANEL::NODATA")} </Wrapper>
      ) : (
        children
      )}
    </>
  );
}

export default RadarlyFilterbarPanelsInnerPanel;
